<template>
  <div>
    <navigation />
    <div class="search-container">
      <div class="search-condition">
        <div class="id-search">
          <span>画框ID：</span>
          <input
            v-model="annoIds"
            placeholder="请输入画框ID"
            @keyup.enter="searchImage()"
            style="margin-right: 18px;"
          />
          <span>图片ID：</span>
          <input v-model="imageIds" placeholder="请输入图片ID" @keyup.enter="searchImage()" />
          <label class="duoview-label"> <input type="checkbox" v-model="dualView" />查双视角 </label>
        </div>
        <div class="condition-search">
          <select v-model="searchMode" style="height: 35px;width: 150px;">
            <option :value="0">默认搜索模式</option>
            <option :value="1">类别聚合模式</option>
          </select>
          <input
            v-model="taskName"
            placeholder="请输入任务名"
            @keyup="taskNameInput()"
            @keyup.enter.esc="taskListFilter = []"
            @blur="taskListFilter = []"
          />
          <div class="taskname-list" v-if="taskListFilter.length !== 0">
            <div
              class="taskname-item"
              v-for="task of taskListFilter"
              :key="`task${task.taskId}`"
              @mousedown="chooseOption('task', task)"
            >
              {{ task.taskName }}
            </div>
          </div>
          <div class="classname" :style="{ height: clsstatus ? '35px' : '400px' }">
            <span
              @click="classPopup = true"
              style="width: 180px;height:35px;box-sizing: border-box;border: 1px solid #dddddd;border-radius: 4px;font-size: 14px;padding: 8px 12px;background-color: #fafafa;display: inline-block;overflow: hidden;"
              :style="{ color: classNames ? '#000000' : '#aaaaaa' }"
              >{{ classNames ? classNames : '请选择类别' }}</span
            >
            <div id="select-class-popup" v-if="classPopup" @keyup.esc="classPopup = false">
              <span @click="classPopup = false" style="position: absolute;right: 20px;">X</span>
              <span class="title">已选中的类别：</span>
              <div class="chosen-class">
                <span>{{ classNames }}</span>
              </div>
              <span class="title">候选类别：</span>
              <input
                v-model="classSearch"
                placeholder="输入class搜索"
                style="margin-bottom: 16px;background-color: #ffffff;"
              />
              <div class="all-class">
                <div
                  v-for="c of classListFilter"
                  :key="`class${c.classId}`"
                  class="all-class-items"
                  :class="classIds.includes(c.classId) ? 'active' : ''"
                  @click="toggleClass(c.classId)"
                >
                  {{ c.className }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="search-button">
          <button @click="searchImage()">搜索</button>
          <button class="hollow-btn" @click="$router.go(0)">清除</button>
        </div>
      </div>
      <div class="search-result" ref="result" :key="0">
        <div
          class="annopanel"
          v-for="(image, index) of imageList"
          :key="`${image.imageId}-${index}`"
          :style="{ top: image.top, left: image.left }"
          @click.left="toImageDetail(image, null, 0)"
          @click.right="toImageDetail(image, null, 1)"
        >
          <AnnoPanel
            :src="image.url"
            ref="annopanel"
            :annos="normalizeAnnos(image.annotations, image.taskTypeId)"
            :mode="1"
            maskColor="transparent"
            :style="{ width: '295px', maxHeight: '600px', background: '#eeeeee' }"
          ></AnnoPanel>
          <div class="image-info">
            <el-tooltip placement="top" :content="image.name">
              <span style="flex: 1 0 auto; margin-right: 8px">{{ image.imageId }}</span>
            </el-tooltip>
            <el-tooltip placement="top" :content="image.taskName">
              <span style="flex: 0 1 160px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">{{
                image.taskName
              }}</span>
            </el-tooltip>
            <span style="flex: 1 1 auto; margin-left: 8px">{{ imageStatusMap[image.taskImageStatus] }}</span>
          </div>
        </div>
      </div>
      <div class="search-anno-result">
        <div
          class="anno-card"
          v-for="anno of annoList"
          :key="`anno${anno.id}`"
          @click="toImageDetail(anno.image_id, anno.taskId)"
        >
          <AnnoPanel
            :src="annoToImageUrl(anno)"
            ref="annopanel"
            :annos="normalizeAnnosDeviation(anno)"
            :mode="1"
            maskColor="transparent"
          ></AnnoPanel>
        </div>
      </div>
      <pagination
        :page-size="pageSize"
        :page-index="pageIndex"
        :item-total="itemTotal"
        @changeindex="changePageIndex"
        @changesize="changePageSize"
      />
    </div>
  </div>
</template>

<script>
import * as api from '@/api/api.js';
import AnnoPanel from '@/components/AnnoPanel.vue';
import pagination from '@/components/pagination';
import navigation from '@/components/navigation';
import { taskTypeMap } from '@/config';
import { imageStatusMap } from '@/config';

export default {
  name: 'search',
  data: function() {
    return {
      searchMode: 0,
      classPopup: false,
      classSearch: '',
      annoIds: '',
      imageIds: '',
      dualView: false,
      taskList: [],
      userList: [],
      classList: [],
      classMap: {},
      imageList: [],
      annoList: [],
      searchType: 'detail',
      searchItem: {},
      taskName: '',
      taskListFilter: [],
      taskId: null,
      className: '',
      classIds: [],
      annotatorName: '',
      annotatorId: null,
      imageStatusMap: [],
      customerList: [],
      customerId: null,
      clsstatus: true,
      fun: null,
      chooseFlag: { user: 0, task: 0 },
      // 分页变量
      pageSize: 20,
      pageIndex: 0,
      itemTotal: 0,
      // 瀑布流变量
      waterfallImgWidth: 295,
      waterfallPadding: 6,
      waterfallDeviationHeight: [], // 存放瀑布流各个列的高度
    };
  },
  components: {
    AnnoPanel,
    pagination,
    navigation,
  },
  computed: {
    classNames: function() {
      return this.classIds.map(v => this.classList.find(m => v === m.classId).className).join(',');
    },
    classListFilter: function() {
      let classList = JSON.parse(JSON.stringify(this.classList));
      classList.sort((a, b) => a.className.localeCompare(b.className));
      if (this.classSearch) return classList.filter(v => v.className.indexOf(this.classSearch) !== -1);
      else return classList;
    },
  },
  mounted: function() {
    let _this = this;
    document.onkeydown = function() {
      let key = window.event.keyCode;
      // 按esc隐藏搜索辅助的浮窗
      if (key === 27 && _this.classPopup === true) {
        _this.classPopup = false;
      }
    };
    this.imageStatusMap = imageStatusMap;
    api
      .getUserList({ p: 0, s: 999, r: 2 })
      .then(res => {
        this.customerList = res.data.users;
        // 优先默认客户为海深安检
        this.customerId = this.customerList[
          this.customerList.findIndex(v => v.userName === '海深安检')
            ? this.customerList.findIndex(v => v.userName === '海深安检')
            : 0
        ].userId;
        this.getClassInfo();
        this.getTaskList();
      })
      .catch(() => {});
  },
  methods: {
    toggleClass(classId) {
      if (this.classIds.includes(classId))
        this.classIds.splice(
          this.classIds.findIndex(v => v === classId),
          1,
        );
      else this.classIds.push(classId);
    },
    taskNameInput() {
      this.taskListFilter = this.taskList.filter(v => v.taskName.indexOf(this.taskName) !== -1);
      this.taskId = null;
    },
    // position 0-左击事件， 1-右击事件
    toImageDetail(image, taskId, position) {
      if (taskId) {
        if (position === 1) {
          const route = this.$router.resolve({
            path: `/image/` + image,
            query: {
              f: 's',
              tid: taskId,
            },
          });
          window.open(route.href, '_blank');
        } else {
          this.$router.push({
            path: `/image/` + image,
            query: {
              f: 's',
              tid: taskId,
            },
          });
        }
      } else {
        let query = {
          tid: image.taskId,
        };
        Object.assign(query, this.searchItem);
        query.f = 's';
        this.$store.commit('setAdminImageList', {
          imageList: this.imageList.map(v => {
            return { imageId: v.imageId, taskId: v.taskId };
          }),
        });
        if (position === 1) {
          const route = this.$router.resolve({ path: `/image/${image.imageId}`, query });
          localStorage.setItem('store', JSON.stringify(this.$store.state));
          window.open(route.href, '_blank');
        } else {
          this.$router.push({ path: `/image/${image.imageId}`, query });
        }
      }
    },
    getPanelPos(image) {
      let minIndex = this.waterfallDeviationHeight.indexOf(Math.min(...this.waterfallDeviationHeight));
      image.top = `${this.waterfallDeviationHeight[minIndex]}px`;
      image.left = `${minIndex * (this.waterfallPadding * 2 + this.waterfallImgWidth)}px`;
      this.waterfallDeviationHeight[minIndex] +=
        Math.min(...[(this.waterfallImgWidth * image.height) / image.width, 600, image.height]) +
        2 * this.waterfallPadding +
        36;
      this.$refs.result.style.height = `${Math.max(...this.waterfallDeviationHeight) + 33}px`;
      return image;
    },
    debounce(fn, delay) {
      if (this.fun !== null) {
        clearTimeout(this.fun);
      }
      this.fun = setTimeout(fn, delay);
    },
    chooseOption(type, value) {
      this.taskName = value.taskName;
      this.taskId = value.taskId;
      this.taskListFilter = [];
    },
    getClassInfo() {
      api
        .getUserTotalClassesNew()
        .then(res => {
          this.classifications = res.data.classifications;
          this.classList = this.classifications.map(v => ({ classId: v.id, className: v.name }));
        })
        .catch(() => {});
    },
    getTaskList() {
      api
        .getTaskListByUser({ userId: this.customerId })
        .then(res => {
          this.taskList = [];
          this.taskList = res.data.tasks;
        })
        .catch(() => {});
    },
    searchImage(pi = 0) {
      if (this.searchMode === 1) {
        this.pageSize = 50;
        if (this.classIds.length === 0) {
          this.$notify({
            group: 'foo',
            type: 'custom-red',
            text: `请选择类别`,
            duration: 1500,
          });
          return;
        }
      } else {
        this.pageSize = 20;
      }
      this.taskListFilter = [];
      this.clsstatus = true;
      this.pageIndex = pi;
      this.searchItem = {
        page: this.pageIndex,
        pagesize: this.pageSize,
        customerid: this.customerId,
        mode: this.searchMode,
      };
      if (this.annoIds) this.searchItem['annoids'] = this.annoIds;
      if (this.imageIds) this.searchItem['imageids'] = this.imageIds;
      if (this.dualView) this.searchItem['duoview'] = 1;
      if (this.taskId) this.searchItem['taskid'] = this.taskId;
      else this.searchItem['taskname'] = this.taskName;
      if (this.classIds.length) this.searchItem['classids'] = this.classIds;
      if (this.annotatorId) this.searchItem['annotatorid'] = this.annotatorId;
      api
        .directlySearch(this.searchItem)
        .then(res => {
          this.imageList = [];
          this.annoList = [];
          this.$refs.result.style.height = '0px';
          this.$store.commit('setKeepAlive', ['search']);
          if (this.searchMode === 0) {
            this.waterfallDeviationHeight = Array(
              parseInt(this.$refs.result.offsetWidth / (this.waterfallImgWidth + 2 * this.waterfallPadding)),
            ).fill(0);
            this.imageList = res.data.images.map(v => this.getPanelPos(v));
            this.imageList.forEach(img => {
              img.annotations.forEach(anno => {
                anno['title'] = anno.classIds.map(cls => this.classMap[cls]).join(',');
              });
            });
            this.itemTotal = res.data.imageCount;
            if (res.data.unSearchedIds && res.data.unSearchedIds.length) {
              this.$notify({
                group: 'foo',
                type: 'custom-red',
                text: `未搜索到的ID：${res.data.unSearchedIds.join(',')}`,
                duration: 1500,
              });
            }
            if (res.data.imageCount === 0) {
              this.$notify({
                group: 'foo',
                type: 'custom-red',
                text: '没有满足条件的标注',
                duration: 1500,
              });
            } else {
              this.$notify({
                group: 'foo',
                type: 'custom-blue',
                text: `搜索到${res.data.imageCount}张满足条件的图片`,
                duration: 1500,
              });
            }
          } else if (this.searchMode === 1) {
            this.annoList = res.data.annoList;
            this.annoList.forEach(anno => {
              anno['title'] = anno.class_ids.map(cls => this.classMap[cls]).join(',');
            });
            this.itemTotal = res.data.annoCount ? parseInt(res.data.annoCount) : 0;
          }
        })
        .catch(() => {});
    },
    annoToImageUrl(anno) {
      let p = anno.bbox.match(/\d+/g);
      return `${anno.url}?imageMogr2/crop/!${parseInt(p[0] - p[2]) + 14}x${parseInt(p[1] - p[3]) + 14}a${
        parseInt(p[2]) - 7 > 0 ? parseInt(p[2]) - 7 : 0
      }a${parseInt(p[3]) - 7 > 0 ? parseInt(p[3]) - 7 : 0}`;
    },
    normalizeAnnosDeviation(anno) {
      let p = anno.bbox.match(/\d+/g);
      return [
        {
          id: anno.id,
          type: taskTypeMap[anno.task_type_id],
          // cat: anno.class_ids[0],
          cat: -5,
          data: anno.points.map(v =>
            v.map(v => [v[0] - (p[2] - 7 > 0 ? p[2] - 7 : 0), v[1] - (p[3] - 7 > 0 ? p[3] - 7 : 0)]),
          ),
          title: this.classList.find(v => v.classId === anno.cat).className,
        },
      ];
    },
    normalizeAnnos(annotations, taskTypeId) {
      return annotations.map(anno => {
        return {
          id: anno.id,
          type: taskTypeMap[taskTypeId],
          cat: anno.classIds[0].classId,
          data: anno.points,
          title: anno.classIds[0].className,
        };
      });
    },
    changePageIndex: function(pi) {
      this.pageIndex = pi;
      this.searchImage(pi);
    },
    changePageSize: function(ps) {
      this.pageSize = parseInt(ps);
      this.searchImage();
    },
  },
};
</script>
<style scoped>
select {
  width: 90px;
  height: 33px;
  appearance: none;
  background-image: url('~@/assets/select-arrow.png');
  background-repeat: no-repeat;
  background-position: 90%;
  background-size: 14px;
  background-color: #fafafa;
  color: #595959;
  padding: 9px 12px;
  font-size: 14px;
  line-height: 100%;
  outline: none;
  border-radius: 4px;
  border: 1px solid #dddddd;
}
input {
  box-sizing: border-box;
  height: 32px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  font-size: 14px;
  padding: 0px 12px;
  outline: none;
  background-color: #fafafa;
}
button {
  margin: 0px;
  height: 32px;
  width: 65px;
  font-size: 14px;
}
.annopanel {
  position: absolute;
  margin: 5px;
  display: inline-block;
  border: 1px solid #eeeeee;
  background: #ffffff;
}
.search-result {
  position: relative;
}
.search-type {
  border: 1px solid #dddddd;
  border-radius: 3px;
  display: inline-block;
  overflow: hidden;
  box-sizing: border-box;
}
.search-type select {
  height: 33px;
  border: none;
  border-radius: 0px;
  border-right: 1px solid #dddddd;
}
.search-type input {
  height: 33px;
  border: none;
}
.image-info {
  width: 295px;
  padding: 8px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}
.image-info > span {
  display: inline-block;
  /*margin-right: 10px;*/
}
.name-search {
  display: inline-block;
  position: relative;
  vertical-align: top;
}
.name-search div {
  display: inline-block;
  position: relative;
  margin-right: 18px;
}
.name-search button {
  float: right;
}
.name-search select,
input {
  height: 35px;
  width: 180px;
}
.name-search > select {
  margin-right: 18px;
  color: #000000;
}
.taskname-list {
  left: 198px;
  top: 36px;
  width: 178px;
}
.username-list {
  left: 0px;
  top: 35px;
  width: 178px;
}
div[class$='-list'] {
  position: absolute;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  z-index: 99;
  margin-right: 0px;
  background: #ffffff;
}
div[class$='-item'] {
  cursor: pointer;
  margin: 0px;
  padding: 5px;
  width: -webkit-fill-available;
}
div[class$='-item']:hover {
  background: #f5f5f5;
}
.name-search .classname {
  position: static;
  margin-left: 16px;
  vertical-align: top;
}
.classname > select {
  width: 180px;
  height: 100%;
  color: #000000;
  background-image: none;
}
.classname > img {
  width: 14px;
  display: inline-block;
  vertical-align: top;
  margin: 13px 10px;
}
.classname > select.select-default {
  color: #bbbbbb;
}
.search-button {
  position: absolute;
  right: 0px;
  top: 0px;
}
.search-button > button {
  margin-left: 18px;
}
.search-condition {
  position: relative;
}
#select-class-popup {
  position: absolute;
  width: 500px;
  height: 600px;
  margin: 0px;
  padding: 20px;
  top: 0px;
  left: 280px;
  z-index: 90;
  background-color: #fafafa;
  border: 1px solid #dddddd;
  border-radius: 8px;
}
#select-class-popup div {
  display: block;
}
#select-class-popup span.title {
  font-size: 18px;
  display: block;
  margin: 8px 0px;
}
#select-class-popup .all-class-items {
  display: block;
}
#select-class-popup .chosen-class {
  height: 10%;
  overflow: scroll;
  margin: 0px;
  background-color: #ffffff;
}
.chosen-class {
  border: 1px solid #dddddd;
  border-radius: 4px;
  padding: 6px;
}
#select-class-popup .all-class {
  overflow: scroll;
  height: 65%;
  margin: 0px;
  background-color: #ffffff;
}
.all-class {
  border: 1px solid #dddddd;
  border-radius: 4px;
}
.all-class-items {
  margin-right: 0px;
  padding: 4px 0px 4px 8px;
}
.all-class-items.active {
  background-color: #dddddd;
  margin-right: 0px;
}
.anno-card {
  display: inline-block;
  margin: 10px;
}
.duoview-label {
  display: inline-block;
  margin-left: 18px;
  font-size: 14px;
  vertical-align: middle;
  cursor: pointer;
}
.duoview-label input[type='checkbox'] {
  width: 14px;
  height: 14px;
  margin: 0 4px 0 0;
  padding: 0;
  border: 1px solid #dddddd;
  border-radius: 2px;
  background-color: #fafafa;
  vertical-align: middle;
}
.id-search {
  margin-bottom: 18px;
  display: block;
}
.condition-search {
  display: block;
}
.condition-search > select {
  display: inline-block;
  margin: 0px 12px 0px 0px;
  vertical-align: top;
}
.condition-search > input {
  display: inline-block;
  margin: 0px 12px 0px 0px;
  vertical-align: top;
}
.condition-search > div {
  display: inline-block;
  margin: 0px 12px 0px 0px;
  vertical-align: top;
}
</style>
